import axios from "axios";
import ApiException from "@/models/exceptions/ApiException";

class ApiService {
  instance = null;

  constructor(requestConfig) {
    const axiosConfig = requestConfig ?? {};
    axiosConfig.useDataOnly = true;
    this.instance = axios.create(axiosConfig);
    this.instance.interceptors.response.use(
      (res) => (res.config.useDataOnly ? res?.data ?? null : res),
      async (error) => {
        if (axios.isCancel(error)) {
          error.name = "AbortError";
          throw error;
        }
        const { Message: errMsg } = error.response?.data || {};
        return Promise.reject(new ApiException(error, errMsg ?? ""));
      },
    );
  }
}

export default ApiService;
